export default __webpack_public_path__ + "static/media/pic9.9ca3a042.jpg";